import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import AdyenCheckout from '@adyen/adyen-web';
import '@adyen/adyen-web/dist/adyen.css';
import { PaymentService } from 'src/app/service/payment.service';

@Component({
  selector: 'app-app-online-payment-adyen',
  templateUrl: './app-online-payment-adyen.component.html',
  styleUrls: ['./app-online-payment-adyen.component.scss']
})

export class AppOnlinePaymentAdyenComponent implements OnInit {
  @ViewChild('hook', { static: true }) hook: ElementRef;
  type: string = '';
  clientKey: string = "123test_LUDQC2CKQRAV7MTAPMDAYAY34UYKC24M"; //environment.clientKey as string;

  payCash: FormGroup;
  queryData: any;
  amountRemaining: boolean;

  adyenResponse: any = {};

  paymentLocal: any = 'en_US';
  paymentEnviornment: any = 'test';


  constructor(private fb: FormBuilder, private paymentService: PaymentService, private router: Router, private aRoute: ActivatedRoute) {
    this.hook = new ElementRef('');
  }


  ngOnInit(): void {
    this.aRoute.queryParams.subscribe((queryData) => {
      this.queryData = queryData;

      // this.getPromotionsForTransaction();
      this.setValidationForField()

    });

    this.initBillingForm();

    this.type = "dropin"; //this.route.snapshot.queryParamMap.get('type') || '';

    // this.apiService.getPaymentMethods().subscribe(
    //   (res) => {
    //   console.log('getPaymentMethods',res);

  }
  //    );



  initBillingForm() {
    this.payCash = this.fb.group({
      // Amount: [null]
    })
  }
  get form() { return this.payCash.controls }
  setValidationForField() {
    this.paymentService.getOnlinePaymentMagPiePayNow({ MerchantOrderNo: this.queryData['merchantOrderNo'], TransactionHeadId: this.queryData['transId'] }).subscribe(async (dataFromApi) => {
      console.log('getOnlinePaymentAdyenPayNow', dataFromApi);
      if (dataFromApi['Success']) {

        this.clientKey = dataFromApi['Result']['PaymentGateway']['ClientKey'];
        this.paymentLocal = dataFromApi['Result']['PaymentGateway']['ShopperLocale'];
        this.paymentEnviornment = dataFromApi['Result']['PaymentGateway']['PaymentEnviornment'];
        this.adyenResponse = dataFromApi['Result']

        console.log(this.clientKey)
        console.log(this.paymentLocal)
        console.log(this.paymentEnviornment)

        const configuration = {
          paymentMethodsResponse: { "paymentMethods": [{ "brands": ["mc", "visa"], "details": [{ "key": "encryptedCardNumber", "type": "cardToken" }, { "key": "encryptedSecurityCode", "type": "cardToken" }, { "key": "encryptedExpiryMonth", "type": "cardToken" }, { "key": "encryptedExpiryYear", "type": "cardToken" }, { "key": "holderName", "optional": true, "type": "text" }], "name": "Credit Card", "type": "scheme" }] },// res,
          clientKey: this.clientKey,
          locale: this.paymentLocal,
          environment: this.paymentEnviornment,
          showPayButton: true,
          paymentMethodsConfiguration: {
            ideal: {
              showImage: true,
            },
            // card: {
            //   hasHolderName: true,
            //   holderNameRequired: true,
            //   name: 'Credit or debit card',
            //   amount: {
            //     value: 1000,
            //     currency: 'EUR',
            //   },
            // },
          },
          onSubmit: (state: any, component: any) => {
            if (state.isValid) {
              this.initiatePayment(state, component);
            }
          },
          onAdditionalDetails: (state: any, component: any) => {
            this.submitAdditionalDetails(state, component);
          },
        };
        const checkout = await AdyenCheckout(configuration);

        checkout.create(this.type).mount(this.hook.nativeElement);
      }
    })
  }
  // submit() {

  //   // let param = {id_trx:this.queryData['transId']};
  //   //this.opentab.post(param,"https://metrofitt.scopewebstore.com:785/");

  //   let data = this.payCash.value;
  //   data['TransactionHeadId'] = this.queryData['transId'];
  //   data['MerchantOrderNo'] = this.queryData['merchantOrderNo'];
  //   this.memberService.getPaymentOnlinePayNow(data).subscribe((dataFromApi) => {
  //     console.log(dataFromApi)
  //     if (dataFromApi['Success']) {
  //       let PaymentRequestSubmitUrl = dataFromApi['Result']['PaymentRequestSubmitUrl'];
  //       let param = { access_code: dataFromApi['Result']['AccessCode'], encRequest: dataFromApi['Result']['EncRequest'] };

  //       console.log(PaymentRequestSubmitUrl)
  //       console.log(param)
  //       this.opentab.post(param, PaymentRequestSubmitUrl);
  //     }
  //     else {
  //       this.alertService.openAlertDialog({ status: 'error', title: '', message: dataFromApi['Message'] })
  //     }
  //   })
  // }


  back() {
    this.router.navigate(['../'], { relativeTo: this.aRoute, queryParams: this.queryData })
  }


  async initiatePayment(state: any, component: any) {
    console.log('initiatePayment', state)

    let data = this.payCash.value;
    data['TransactionHeadId'] = this.queryData['transId'];
    data['MerchantOrderNo'] = this.queryData['merchantOrderNo'];
    data['StateData2'] = state;

    console.log('data',data);
    // this.paymentService.makePaymentAyden(data).subscribe((dataFromApi) => {
    //   console.log('makePaymentAyden....', dataFromApi)
    //   if (dataFromApi['Success']) {
    //    // this.memberService.paymentAdded(true);

    //    console.log('success')
      
    //     this.router.navigate(['/', 'app-online-payment-success'])
    //     // if (this.queryData['merchantOrderNo'].includes('UC') ) {

    //     //   this.router.navigate(['/', 'app', 'members', this.queryData['custId'], 'message-success'], { relativeTo: this.aRoute, queryParams: this.queryData })
    //     // }
    //     // else {
    //     //   this.alertService.openAlertDialog({ title: '', message: dataFromApi['Message'] })
    //     //   this.router.navigate(['../'], { relativeTo: this.aRoute, queryParams: this.queryData })
    //     // }
    //   }
    //   else {

    //     console.log('failed')
    //     this.router.navigate(['/', 'app-online-payment-failed'])

    //     // if (this.queryData['merchantOrderNo'].includes('UC')) {

    //     //   this.router.navigate(['/', 'app', 'members', this.queryData['custId'], 'message-failed'], { relativeTo: this.aRoute, queryParams: this.queryData })
    //     // }
    //     // else {
    //     //   this.alertService.openAlertDialog({ status: 'error', title: '', message: dataFromApi['Message'] })
    //     // }
    //   }
    // })

    // try {
    //   this.apiService.initiatePayment(state.data).subscribe((res) => {
    //     this.handleServerResponse(res, component);
    //   });
    // } catch (error) {
    //   console.error(error);
    //   alert('Error occurred. Look at console for details');
    // }
  }

  async submitAdditionalDetails(state: any, component: any) {
    console.log('submitAdditionalDetails', state)
    // try {
    //   this.apiService.submitAdditionalDetails(state.data).subscribe((res) => {
    //     this.handleServerResponse(res, component);
    //   });
    // } catch (error) {
    //   console.error(error);
    //   alert('Error occurred. Look at console for details');
    // }
  }

  handleServerResponse(res: any, component: any) {
    if (res.action) {
      component.handleAction(res.action);
    } else {
      switch (res.resultCode) {
        case 'Authorised':
          this.router.navigate(['/result/success']);
          break;
        case 'Pending':
        case 'Received':
          this.router.navigate(['/result/pending']);
          break;
        case 'Refused':
          this.router.navigate(['/result/failed']);
          break;
        default:
          this.router.navigate(['/result/error']);
          break;
      }
    }
  }
}


